import {useState} from 'react';

import {Post} from '../lib/api/POST/Post';
import {PostRoutes} from '../lib/api/POST/PostRoutes';
import {SecureObjectDelete} from '../lib/api/RequestBodies/secure-s3-file-manipulation/SharedSecureS3FileManipulations';
import {SecureObjectDeleteResponse} from '../types/shared-S3-file-manipulation';

import {useApiWrite} from './useApiWrite';

interface Props {
  scope: 'companies' | 'applicants';
  ownerId: string;
  objectType: 'profile_picture' | 'resume' | 'media' | 'logo';
  onSuccess: (response: Response) => void;
}

export const useSecureS3Delete = ({scope, ownerId, objectType, onSuccess}: Props) => {
  const [error, setError] = useState<Error | null>(null);

  const {makeRequest: getPresignedUrl, error: errorFetchingUrl} = useApiWrite<
    Post.SecureObjectDelete,
    SecureObjectDeleteResponse
  >({
    method: 'post',
    path: PostRoutes[Post.SecureObjectDelete],
    onSuccess: (data: SecureObjectDeleteResponse) => {
      deleteUsingPresignedUrl(data.secureObjectDeletion.presignedUrl);
    },
  });

  const makeRequest = (fileName: string) => {
    setError(null);

    const body: SecureObjectDelete = {
      secureObjectDeletion: {
        scope: scope,
        ownerId: ownerId,
        objectType: objectType,
        filename: fileName,
        contentType: '',
        byteSize: 0,
        checksum: null,
      },
    };

    getPresignedUrl(body);
  };

  const deleteUsingPresignedUrl = async (presignedUrl: string) => {
    try {
      const response = await fetch(presignedUrl, {
        method: 'DELETE',
      });

      if (response.ok) {
        onSuccess(response);
      } else {
        setError(new Error('Failed to delete file'));
      }
    } catch (err) {
      setError(err as Error);
    }
  };

  return {
    makeRequest,
    error: error || errorFetchingUrl,
  };
};
